import {
    GET_ALL_ROOMS,
    GET_ROOM,
    GET_ROOM_BY_LOCATION,
    CAR_LOADING,
    ADD_ROOM
  } from "../actions/ExtracurricularCoursesAdminRoomsAction";
  
  
  const initialState = {
    roomslist: [],
    roomslistLoc: [],
    room: [],
    loading: false,
    add: false,
  };
  
  const UserAdmin = function(state = initialState, action) {
    switch (action.type) {
        case CAR_LOADING: {
          return {
            ...state,
            loading: true,
            add: false
          };
        }
        case GET_ALL_ROOMS: {
            return{
                ...state,
                roomslist : [...action.data],
                room:[],
                loading: false,
                add : false,
            }
        }
        case GET_ROOM: {
          return{
              ...state,
              room : [...action.data],
              loading: false
          }
        }
        case GET_ROOM_BY_LOCATION: {
          return{
              ...state,
              roomslistLoc : [...action.data],
              loading: false
          }
        }
        case ADD_ROOM: {
          return {
            ...state,
            room:[],
            add : true,
            loading: false  
          };
        }
        default: {
            return state;
          }
        }
  }
  
  export default UserAdmin;
  